import { Button, Icon } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import CalendarViewTypeButton from "./CalendarViewTypeButton";

export default function CalendarHeaderToolbarNavigation({ navigation, viewType, disableTools }) {
	const { t } = useTranslation();

	return (
		<div>
			<Button basic size="tiny" onClick={navigation.onTodayClick}>
				{t("today", "Today")}
			</Button>

			<Button basic size="tiny" icon onClick={navigation.onLeftNavigationClick}>
				<Icon name="chevron left" />
			</Button>

			<Button basic style={{ marginRight: 20 }} size="tiny" icon onClick={navigation.onRightNavigationClick}>
				<Icon name="chevron right" />
			</Button>

			<CalendarViewTypeButton
				viewPeriod={"Day"}
				navigation={navigation}
				viewType={viewType}
				disableTools={disableTools}
			>
				{t("day", "Day")}
			</CalendarViewTypeButton>

			<CalendarViewTypeButton
				viewPeriod={"Week"}
				navigation={navigation}
				viewType={viewType}
				disableTools={disableTools}
			>
				{t("week", "Week")}
			</CalendarViewTypeButton>

			<Button
				basic
				size="tiny"
				onClick={() => navigation.changeView("resourceTimelineMonth")}
				active={viewType === "resourceTimelineMonth"}
				style={{ padding: 10 }}
			>
				{t("month", "Month")}
			</Button>
		</div>
	);
}
